import { useState, useEffect } from "react";
import { Form, Alert } from "antd";
import CustomButton from "../../components/CustomButton/Button";
import AuthCardLayout from "../../components/Auth/AuthCardLayout";
import PasswordInput from "../../components/Auth/PasswordInput";
import { useNavigate, useLocation } from "react-router-dom";
import { reset, clearAuthError } from "../../redux/slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { confirmPasswordRules, passwordRules } from "../../helpers/helpers";
import { BTN_TXT, TITLE_TXT } from "../../constants/constants";
import CryptoJS from 'crypto-js';

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { reset_token } = location.state || {};
  const [visible, setVisible] = useState(false);
  const { loading, error } = useSelector((state) => state.auth);
  const [form] = Form.useForm();

  useEffect(() => {
    return () => {
      dispatch(clearAuthError());
    };
  }, [dispatch]);

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  const onFinish = async (values) => {
    const newHashedPassword = CryptoJS.SHA256(values.enterPassword).toString();

    const payload = {
      reset_token,
      password: newHashedPassword,
    };

    const res = await dispatch(reset(payload));

    if (res.payload.statusCode === 200) {
      navigate("/login");
    }
  };

  return (
    <AuthCardLayout title={TITLE_TXT.CHNG_PWD_TITLE}>
      <Form
        form={form}
        layout="vertical"
        className="forgot-form"
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <PasswordInput
          label="Enter New Password"
          name="enterPassword"
          visible={visible}
          onToggleVisibility={toggleVisibility}
          placeholder="Enter Password"
          rules={passwordRules}
        />

        <PasswordInput
          label="Confirm New Password"
          name="confirmPassword"
          visible={visible}
          onToggleVisibility={toggleVisibility}
          placeholder="Re-enter Password"
          rules={confirmPasswordRules}
        />
        {error && (
          <Alert
            style={{ marginTop: 20 }}
            message={error}
            type="error"
            showIcon
          />
        )}
        <Form.Item>
          <CustomButton
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            style={{ marginTop: 20, padding: 24 }}
          >
            {BTN_TXT.SUBMIT}
          </CustomButton>
        </Form.Item>
        <Form.Item>
          <CustomButton
            type="text"
            block
            style={{ fontWeight: 600, padding: 0 }}
            onClick={() => navigate(-1)}
          >
            {BTN_TXT.BACK}
          </CustomButton>
        </Form.Item>
      </Form>
    </AuthCardLayout>
  );
};

export default ResetPassword;
